// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import mergeReducer from "@toolkit/Framework/Common/Utilities/redux/mergeReducer";
import pagesReducer from "@store/Extensions/Store/Pages/PagesReducer";

reducers.pages = mergeReducer(reducers.pages, pagesReducer);
